import { BACKEND_URL } from "./api";

export const DEFAULT_IMAGES = {
  logo: "https://static.prod-images.emergentagent.com/jobs/92ea1810-69b0-49e6-b8b2-a99eefac695b/images/ad56a9c9a6bbbd3073aef448bf8e3c0aac4405c2f544d06b4fe553ac28a1839e.jpeg",
  hero_desktop: "https://static.prod-images.emergentagent.com/jobs/92ea1810-69b0-49e6-b8b2-a99eefac695b/images/9e8acdf51fc25dfe12443bc5839be61f90ce2a38193839dfdc1e24696e26e9cb.jpeg",
  hero_mobile: "https://static.prod-images.emergentagent.com/jobs/92ea1810-69b0-49e6-b8b2-a99eefac695b/images/77ffcdc05bf70e4ac307b463aa82f65dfb78d7513de57517383165b701c82d37.jpeg",
  artwork_artist: "https://static.prod-images.emergentagent.com/jobs/92ea1810-69b0-49e6-b8b2-a99eefac695b/images/5a77c991a178ccadca61cf6de82ba9cd51d7f6590f19c725347bb30e62274800.jpeg",
  artwork_beatmaker: "https://static.prod-images.emergentagent.com/jobs/92ea1810-69b0-49e6-b8b2-a99eefac695b/images/4c1b0ff0431c276a5c8f8c1f9abd13f5c09f55416fd7619f2e18602535609bcc.jpeg",
  default_cover: "https://static.prod-images.emergentagent.com/jobs/92ea1810-69b0-49e6-b8b2-a99eefac695b/images/d6c86068f598d965d3036b92c1705b5f62f7d0923e84e3889684c1a3689de8a1.jpeg",
};

export const SITE_IMAGE_SLOTS = [
  { key: "logo", label: "Logo" },
  { key: "hero_desktop", label: "Hero (desktop)" },
  { key: "hero_mobile", label: "Hero (mobile)" },
  { key: "artwork_artist", label: "Univers artiste" },
  { key: "artwork_beatmaker", label: "Univers beatmaker" },
  { key: "default_cover", label: "Pochette par défaut" },
];

export const resolveImg = (url) => (!url ? null : url.startsWith("http") ? url : `${BACKEND_URL}${url}`);
